import { MainContentLayout } from 'shared/ui/layout';

import { AddCompany } from 'features/company/add';

export function AddCompanyPage() {
  return <MainContentLayout element={<AddCompany />} />;
}
